import React from 'react';
import { Table, Button } from 'react-bootstrap';

const DinamicTableAnalytics = ({ data }) => {

    if (!data || !data.dimensionHeaders || !data.metricHeaders || !data.rows) {
        return null;
    }

    const dimensionHeaders = data.dimensionHeaders.map(header => header.name);
    const metricHeaders = data.metricHeaders.map(header => header.name);

    const titles = {
        "activeUsers": ["Users", ""],
        "unifiedScreenName": ["ScreenName", ""],
        "sessionDefaultChannelGroup": ["Channel Group", ""],
        "newUsers": ["New Users", ""],
        "city": ["City", ""],
        "screenPageViews": ["Views", ""],
        "hostName": ["Host Name", ""],
        "firstUserSource": ["User Source", ""],
        "unifiedPagePathScreen": ["Page Path", ""],
    };

    const tableCellStyle = { width: '200px', wordWrap: 'break-word' };

    return (
        <Table size="sm" striped bordered hover style={{ width: '97%', borderColor: 'lightgreen' }}>
            <thead>
                <tr>
                    {dimensionHeaders.map(header => (
                        <th key={header} style={tableCellStyle}> {titles[header][0]} </th>
                    ))}
                    {metricHeaders.map(header => (
                        <th key={header} style={tableCellStyle}>{titles[header][0]}</th>
                    ))}
                </tr>
            </thead>
            <tbody>
                {data.rows.map((row, index) => (
                    <tr key={index}>
                        {row.dimensionValues.map((dimension, dimensionIndex) => (
                            <td key={`dimension-${index}-${dimensionIndex}`} style={tableCellStyle}>{dimension.value}</td>
                        ))}
                        {row.metricValues.map((metric, metricIndex) => (
                            <td key={`metric-${index}-${metricIndex}`} style={tableCellStyle}>{metric.value}</td>
                        ))}
                    </tr>
                ))}
            </tbody>
        </Table>
    );
};

export default DinamicTableAnalytics;